export enum TravellerXTypeAbbreviation {
    ADT = "ADT",
    CHD = "CHD",
    INF = "INF"
}
